import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import Select from "react-select";
import countryList from "react-select-country-list";
import axios from "axios";
import { getToken } from "../../../utils/storageUtils";
import { useAuthContext } from "../../../hooks/useAuthContext";
import useGetCarDealer from "../../../hooks/useGetCarDealer";
import CurrencyInput from "react-currency-input-field";
import { ClipLoader } from "react-spinners";
import { showToast } from "../../../utils/Toast";
import uploadCarValidation from "../../../utils/validations/upload-car-validation";
import { API_BASE_URL } from "../../../services/baseService";
import { FaTag } from "react-icons/fa";
import { HiUserGroup } from "react-icons/hi";
import registerDealerValidations from "../../../utils/validations/register-dealer-validations";
import { RegionDropdown } from "react-country-region-selector";
import { titleStatusOptions } from "../data/titleStatusOptions";
import { MdCancel } from "react-icons/md";

import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const UploadVehicle = () => {
  const { dealerData } = useGetCarDealer(`car-dealer/get-car-dealer`);
  const [mainloading, setMainLoading] = useState(false);

  const { user } = useAuthContext();
  const navigate = useNavigate();

  const option = useMemo(() => countryList().getData(), []);

  const [carErrors, setCarErrors] = useState({});
  const [dealerErrors, setDealerErrors] = useState({});

  const [buyNowPriceError, setBuyNowPriceError] = useState("");

  const [uploadModalOpen, setUploadModalOpen] = useState(false);

  const [userType, setUserType] = useState("dealer");
  const [, setSelectedOption] = useState("Select sales range");
  const [transmission, setTransmission] = useState("Select transmission type");
  const [additionalFields, setAdditionalFields] = useState([""]);
  const [country, setCountry] = useState("");
  const [region, setRegion] = useState("");
  const [showAdditionalAfterVinFields, setShowAdditionalAfterVinFields] =
    useState(false);

  // toggles
  const [carModificationStatus, setCarModificationStatus] = useState("stock");
  const [selectedOptions, setSelectedOptions] = useState({
    significantFlaws: false,
    isCarForSale: false,
    carTitledInfo: false,
    minPrice: false,
    buyNowPrice: false,
  });

  const [isOpen, setIsOpen] = useState(false);
  const [transmissionIsOpen, setTransmissionIsOpen] = useState(false);

  const [imagePreview, setImagePreview] = useState(null);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [imageCarDocuments, setImageCarDocuments] = useState([]);

  const [carTouchedFields, setCarTouchedFields] = useState({});
  const [dealerTouchedFields, setDealerTouchedFields] = useState({});

  const fileInputRef = useRef(null);
  const filesInputRef = useRef(null);
  const filesCarDocumentsRef = useRef(null);

  const options = ["Less than 10", "10-50", "50-100", "More than 100"];

  const transmissionOptions = ["Automatic", "Manual"];

  const carTitledOptions = [
    { value: "bahamas", label: "Bahamas" },
    { value: "usa", label: "USA" },
  ];
  const bahamasStates = [
    { value: "acklins_island", label: "Acklins Island" },
    { value: "berry_islands", label: "Berry Islands" },
    { value: "bimini", label: "Bimini" },
    { value: "black_point", label: "Black Point" },
    { value: "cat_island", label: "Cat Island" },
    { value: "central_abaco", label: "Central Abaco" },
    { value: "crooked_island_long_cay", label: "Crooked Island and Long Cay" },
    { value: "east_grand_bahama", label: "East Grand Bahama" },
    { value: "exuma", label: "Exuma" },
    { value: "freeport", label: "Freeport" },
    { value: "fresh_creek", label: "Fresh Creek" },
    { value: "governors_harbour", label: "Governor's Harbour" },
    { value: "green_turtle_cay", label: "Green Turtle Cay" },
    { value: "harbour_island", label: "Harbour Island" },
    { value: "high_rock", label: "High Rock" },
    { value: "inagua", label: "Inagua" },
    { value: "kemps_bay", label: "Kemps Bay" },
    { value: "long_island", label: "Long Island" },
    { value: "marsh_harbour", label: "Marsh Harbour" },
    { value: "mayaguana", label: "Mayaguana" },
    { value: "moores_island", label: "Moore's Island" },
    { value: "new_providence", label: "New Providence" },
    {
      value: "nichollstown_berry_islands",
      label: "Nichollstown and Berry Islands",
    },
    { value: "north_abaco", label: "North Abaco" },
    { value: "north_andros", label: "North Andros" },
    { value: "north_eleuthera", label: "North Eleuthera" },
    { value: "ragged_island", label: "Ragged Island" },
    { value: "rock_sound", label: "Rock Sound" },
    { value: "san_salvador_rum_cay", label: "San Salvador and Rum Cay" },
    { value: "sandy_point", label: "Sandy Point" },
    { value: "south_abaco", label: "South Abaco" },
    { value: "south_andros", label: "South Andros" },
    { value: "south_eleuthera", label: "South Eleuthera" },
    { value: "west_grand_bahama", label: "West Grand Bahama" },
  ];

  const customStyles = {
    control: (defaultStyles) => ({
      ...defaultStyles,
      padding: "2px 0px",
    }),
  };

  // const handleCountryChange = (selectedOption) => {
  //   setCountry(selectedOption ? selectedOption.label : "");
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     carDetails: {
  //       ...prevData.carDetails,
  //       carLocation: selectedOption ? selectedOption.label : "",
  //       carState: "", // Reset state when country changes
  //     },
  //   }));
  // };
  // const handleStateChange = (val) => {
  //   setRegion(val);
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     carDetails: {
  //       ...prevData.carDetails,
  //       carState: val,
  //     },
  //   }));
  // };

  // const titlesStatusHandler = (selectedOption) => {
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     carDetails: {
  //       ...prevData.carDetails,
  //       titlesStatus: selectedOption ? selectedOption.label : "",
  //     },
  //   }));
  // };

  const [formData, setFormData] = useState({
    buyerFeeDetails: dealerData ? dealerData?.data?.buyerFeeDetails : "",
    dealershipName: dealerData?.data?.dealershipName || "",
    dealershipWebsite: dealerData?.data?.dealershipWebsite || "",
    vehicleSalesEachMonth: dealerData?.data?.vehicleSalesEachMonth || "",
    fullName: user?.username || "",
    phoneNumber: user?.phone || "",
    carDetails: {
      vin: "",
      year: "",
      make: "",
      model: "",
      transmission: "",
      mileage: "",
      description: "",
      modification: "",
      significantFlaws: "",
      zip: "",
      isCarForSale: [],
      carTitledAt: "",
      carTitledInfo: "",
      referral: "",
      carLocation: "",
      carState: "",
      minPrice: "",
      buyNowPrice: "",
    },

    dealershipLicense: null,
    carImages: [],
    carDocuments: [],
  });

  const validateCarField = (name, value) => {
    const updatedCarDetails = {
      ...formData.carDetails,
      [name]: value,
    };
    const tempFormData = {
      ...formData,
      carDetails: updatedCarDetails,
    };
    const errors = uploadCarValidation(tempFormData);
    setCarErrors((prevErrors) => ({
      ...prevErrors,
      [name]: errors[name] || "", // clear the error if it's gone
    }));
  };

  const validateDealerField = (name, value) => {
    const tempFormData = {
      ...formData,
      [name]: value,
    };
    const errors = registerDealerValidations(tempFormData);
    setDealerErrors((prevErrors) => ({
      ...prevErrors,
      [name]: errors[name] || "",
    }));
  };

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
    setFormData((prevData) => ({
      ...prevData,
      vehicleSalesEachMonth: option,
    }));

    // 👇 Mark the field as touched
    setDealerTouchedFields((prev) => ({
      ...prev,
      vehicleSalesEachMonth: true,
    }));

    // 👇 Run validation immediately after selection
    validateDealerField("vehicleSalesEachMonth", option);
  };

  const handleTransmissionOptionClick = (option) => {
    setTransmission(option);
    setTransmissionIsOpen(false);

    setFormData((prevData) => ({
      ...prevData,
      carDetails: {
        ...prevData.carDetails,
        transmission: option,
      },
    }));

    // Mark as touched only if user actually selects
    setCarTouchedFields((prev) => ({
      ...prev,
      transmission: true,
    }));

    validateCarField("transmission", option);
  };

  // const handleTransmissionOptionClick = (option) => {
  //   setTransmission(option);
  //   setTransmissionIsOpen(false);
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     carDetails: {
  //       ...prevData.carDetails,
  //       transmission: option,
  //     },
  //   }));
  // };
  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     [name]: value,
  //   }));
  // };
  // const handleCarDetailsChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     carDetails: {
  //       ...prevData.carDetails,
  //       [name]: value,
  //     },
  //   }));
  //   if (name === "vin") {
  //     setShowAdditionalAfterVinFields(value.trim() !== "");
  //   }
  // };

  const handleCarDetailsChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      carDetails: {
        ...prevData.carDetails,
        [name]: value,
      },
    }));

    setCarTouchedFields((prev) => ({
      ...prev,
      [name]: true,
    }));

    validateCarField(name, value);

    if (name === "vin") {
      setShowAdditionalAfterVinFields(value.trim() !== "");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    setDealerTouchedFields((prev) => ({
      ...prev,
      [name]: true,
    }));

    validateDealerField(name, value);
  };

  const handleToggleChange = (property) => {
    setSelectedOptions((prevOptions) => ({
      ...prevOptions,
      [property]: !prevOptions[property],
    }));
    setFormData((prevData) => ({
      ...prevData,
      carDetails: {
        ...prevData.carDetails,
        [property]: !selectedOptions[property]
          ? ""
          : prevData.carDetails[property],
      },
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file instanceof File) {
      setFormData((prevData) => ({
        ...prevData,
        dealershipLicense: file,
      }));
      setImagePreview(URL.createObjectURL(file)); // Create a preview URL
    } else {
      // console.error("No valid file selected");
    }
  };

  const handleCancelImage = () => {
    setImagePreview(null);
    fileInputRef.current.value = "";
    setFormData((prevData) => ({
      ...prevData,
      dealershipLicense: null,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMainLoading(true);
    setUploadModalOpen(true); // Start loading

    const newErrors = uploadCarValidation(formData);
    const dealerFormErrors = registerDealerValidations(formData);

    // Mark all car fields as touched to show errors
    // setCarTouchedFields(() => {
    //   const touched = {};
    //   for (const key in formData.carDetails) {
    //     touched[key] = true;
    //   }
    //   return {
    //     ...touched,
    //     carImages: true,
    //     carDocuments: true, // ✅ add this
    //   };
    // });
    // if (!formData.carDetails.transmission) {
    //   setCarTouchedFields((prev) => ({
    //     ...prev,
    //     transmission: true,
    //   }));
    // }

    // if (!formData.carDetails.titlesStatus) {
    //   setCarTouchedFields((prev) => ({
    //     ...prev,
    //     titlesStatus: true,
    //   }));
    // }

    const touched = {};
    for (const key in formData.carDetails) {
      touched[key] = true;
    }
    if (!formData.carDetails.transmission) {
      touched.transmission = true;
    }
    if (!formData.carDetails.titlesStatus) {
      touched.titlesStatus = true;
    }
    touched.carImages = true;
    touched.carDocuments = true;

    setCarTouchedFields(touched);

    // Mark dealer fields as touched (optional but recommended)
    setDealerTouchedFields(() => {
      const touched = {};
      [
        "buyerFeeDetails",
        "dealershipName",
        "dealershipWebsite",
        "vehicleSalesEachMonth",
      ].forEach((field) => {
        touched[field] = true;
      });
      return touched;
    });

    // if (Object.keys(newErrors).length <= 4) {
    //   // Proceed with form submission
    // } else {
    //   setCarErrors(newErrors);
    //   showToast("please fill all field ");
    // }

    const DealerDetails = new FormData();
    DealerDetails.append("buyerFeeDetails", formData.buyerFeeDetails);
    DealerDetails.append("dealershipName", formData.dealershipName);
    DealerDetails.append("dealershipWebsite", formData.dealershipWebsite);
    DealerDetails.append(
      "vehicleSalesEachMonth",
      formData.vehicleSalesEachMonth
    );
    DealerDetails.append("dealershipLicense", formData.dealershipLicense);

    //============================== 2nd data ================================
    const CarDetails = new FormData();
    CarDetails.append("vin", formData.carDetails.vin);
    CarDetails.append("year", formData.carDetails.year);
    CarDetails.append("make", formData.carDetails.make);
    CarDetails.append("model", formData.carDetails.model);
    CarDetails.append("transmission", formData.carDetails.transmission);
    CarDetails.append("mileage", formData.carDetails.mileage);

    CarDetails.append("modification", formData.carDetails.modification);
    CarDetails.append("significantFlaws", formData.carDetails.significantFlaws);
    CarDetails.append("carLocation", formData.carDetails.carLocation);
    CarDetails.append("carState", formData.carDetails.carState);

    // CarDetails.append("description", formData.carDetails.description);
    if (
      formData.carDetails.description &&
      formData.carDetails.description !== "" &&
      formData.carDetails.description !== "undefined" &&
      formData.carDetails.description !== "null" &&
      formData.carDetails.description !== null
    ) {
      CarDetails.append("description", formData.carDetails.description);
    }

    if (
      formData.carDetails.bahamasState &&
      formData.carDetails.bahamasState !== "" &&
      formData.carDetails.bahamasState !== "undefined" &&
      formData.carDetails.bahamasState !== "null" &&
      formData.carDetails.bahamasState !== null
    ) {
      CarDetails.append("bahamasState", formData.carDetails.bahamasState);
    }
    // CarDetails.append("zip", formData.carDetails.zip);

    if (
      formData.carDetails.zip &&
      formData.carDetails.zip !== "" &&
      formData.carDetails.zip !== "undefined" &&
      formData.carDetails.zip !== "null" &&
      formData.carDetails.zip !== null
    ) {
      CarDetails.append("zip", formData.carDetails.zip);
    }

    CarDetails.append("carTitledAt", formData.carDetails.carTitledAt);
    CarDetails.append("carTitledInfo", formData.carDetails.carTitledInfo);
    CarDetails.append("titlesStatus", formData.carDetails.titlesStatus);
    CarDetails.append("minPrice", formData.carDetails.minPrice);
    // CarDetails.append("buyNowPrice", formData.carDetails.buyNowPrice);
    if (
      selectedOptions.buyNowPrice &&
      formData.carDetails.buyNowPrice &&
      formData.carDetails.buyNowPrice !== "" &&
      formData.carDetails.buyNowPrice !== "undefined" &&
      formData.carDetails.buyNowPrice !== "null" &&
      formData.carDetails.buyNowPrice !== null
    ) {
      CarDetails.append("buyNowPrice", formData.carDetails.buyNowPrice);
    }
    CarDetails.append("referral", formData.carDetails.referral);

    // array fields
    if (formData.carDetails.isCarForSale && formData.carDetails.isCarForSale.length > 0) {
      formData.carDetails.isCarForSale.forEach((item, index) => {
        CarDetails.append(`isCarForSale[${index}]`, item);
      });
    }
    
    formData.carImages.forEach((image, index) => {
      CarDetails.append(`carImages`, image);
    });
    formData.carDocuments.forEach((image, index) => {
      CarDetails.append(`carDocuments`, image);
    });

    // =====================================================================================
    if (userType === "dealer") {
      if (!dealerData) {
        if (
          Object.keys(newErrors).length === 0 &&
          Object.keys(dealerFormErrors).length === 0
        ) {
          try {
            await Promise.all([
              axios.post(
                `${API_BASE_URL}car-dealer/register-car-dealer`,
                DealerDetails,
                {
                  headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${getToken()}`,
                  },
                }
              ),
              axios.post(`${API_BASE_URL}local-cars/upload-car`, CarDetails, {
                headers: {
                  "Content-Type": "multipart/form-data",
                  Authorization: `Bearer ${getToken()}`,
                },
              }),
            ]);
            showToast("Vehicle uploaded", "success");
            navigate("/user/account/local-cars");
          } catch (error) {
            if (error.response) {
              showToast(
                `Submission failed: ${
                  error.response.data.message || "An error occurred"
                }`,
                "error"
              );
            } else if (error.request) {
              // Request was made but no response received
              showToast("Submission failed: No response from server", "error");
            } else {
              showToast(`Submission failed: ${error.message}`, "error");
            }
          }
        } else {
          setCarErrors(newErrors);
          setDealerErrors(dealerFormErrors);
          showToast("please fill all field..");
        }
      } else {
        if (Object.keys(newErrors).length === 0) {
          try {
            await axios.post(
              `${API_BASE_URL}local-cars/upload-car`,
              CarDetails,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                  Authorization: `Bearer ${getToken()}`,
                },
              }
            );
            showToast("Vehicle uploaded", "success");
            navigate("/user/account/local-cars");
          } catch (error) {
            if (error.response) {
              showToast(
                `Submission failed: ${
                  error.response.data.message || "An error occurred"
                }`,
                "error"
              );
            } else if (error.request) {
              // Request was made but no response received
              showToast("Submission failed: No response from server", "error");
            } else {
              showToast(`Submission failed: ${error.message}`, "error");
            }
          }
        } else {
          // sjjs
          setCarErrors(newErrors);
          showToast("please fill all field ");
        }
      }
    } else if (userType === "private") {
      if (Object.keys(newErrors).length === 0) {
        // ============================= End Else ======================
        try {
          await axios.post(`${API_BASE_URL}local-cars/upload-car`, CarDetails, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${getToken()}`,
            },
          });
          showToast("Vehicle uploaded", "success");
          navigate("/user/account/local-cars");
        } catch (error) {
          if (error.response) {
            showToast(
              `Submission failed: ${
                error.response.data.message || "An error occurred"
              }`,
              "error"
            );
          } else if (error.request) {
            // Request was made but no response received
            showToast("Submission failed: No response from server", "error");
          } else {
            showToast(`Submission failed: ${error.message}`, "error");
          }
        }
      } else {
        const touched = {};
        for (const key in formData.carDetails) {
          touched[key] = true;
        }

        // ✅ Also touch file upload fields
        touched.carImages = true;
        touched.carDocuments = true;
        touched.titlesStatus = true;

        setCarTouchedFields(touched);
        setCarErrors(newErrors);
        showToast("Please fill all required fields", "error");
      }
    }
    setMainLoading(false);
    setUploadModalOpen(false); // Start loading
  };

  const handleUploadClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click(); // Trigger the file input click event
    }
  };

  const handleAddMoreFields = () => {
    setAdditionalFields((prevFields) => [...prevFields, ""]);
    setFormData((prevData) => ({
      ...prevData,
      carDetails: {
        ...prevData.carDetails,
        isCarForSale: [...prevData.carDetails.isCarForSale, []],
      },
    }));
  };

  const handleAdditionalFieldChange = (index, e) => {
    const newFields = [...additionalFields];
    newFields[index] = e.target.value;
    setAdditionalFields(newFields);
    const newLinks = [...formData.carDetails.isCarForSale];
    newLinks[index] = e.target.value;
    setFormData((prevData) => ({
      ...prevData,
      carDetails: {
        ...prevData.carDetails,
        isCarForSale: newLinks,
      },
    }));
  };

  const handleMinPriceChange = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      carDetails: {
        ...prevData.carDetails,
        minPrice: value,
      },
    }));
  };
  const handleBuyNowPriceChange = (value) => {
    const numericBuyNowPrice = Number(value);
    const numericMinPrice = Number(formData.carDetails.minPrice);

    // Set form data
    setFormData((prevData) => ({
      ...prevData,
      carDetails: {
        ...prevData.carDetails,
        buyNowPrice: value,
      },
    }));

    // Real-time validation
    if (
      numericMinPrice &&
      numericBuyNowPrice &&
      numericBuyNowPrice <= numericMinPrice
    ) {
      setBuyNowPriceError("Buy now price must be greater than reserve price.");
    } else {
      setBuyNowPriceError(""); // clear error if it's valid
    }
  };

  const handleUploadClicks = () => {
    filesInputRef.current.click();
  };

  const handleUploadClicksCarDocuments = () => {
    filesCarDocumentsRef.current.click();
  };

  const handleFileChanges = (e) => {
    const files = Array.from(e.target.files);
    const totalFiles = formData.carImages.length + files.length;

    // Check if total files would exceed 6
    if (totalFiles > 6) {
      showToast("You can only upload a maximum of 6 images", "error");
      e.target.value = ""; // Clear the input
      return;
    }

    // Check file sizes
    const oversizedFiles = files.filter((file) => file.size > 2 * 1024 * 1024); // 2MB in bytes
    if (oversizedFiles.length > 0) {
      showToast(
        "Some files exceed 2MB size limit. Please select smaller files.",
        "error"
      );
      e.target.value = ""; // Clear the input
      return;
    }

    const newFiles = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));

    setFormData((prevData) => {
      const updatedData = {
        ...prevData,
        carImages: [...prevData.carImages, ...files],
      };

      const newErrors = uploadCarValidation({
        ...updatedData,
        carDetails: { ...prevData.carDetails },
      });

      setCarErrors((prevErrors) => ({
        ...prevErrors,
        carImages: newErrors.carImages || "",
      }));

      return updatedData;
    });

    setCarTouchedFields((prev) => ({
      ...prev,
      carImages: true,
    }));

    setImagePreviews((prevPreviews) => [
      ...prevPreviews,
      ...newFiles.map((f) => f.preview),
    ]);
  };

  const handleFileChangesCarDocuments = (e) => {
    const files = Array.from(e.target.files);
    const totalFiles = formData.carDocuments.length + files.length;

    // Check if total files would exceed 6
    if (totalFiles > 6) {
      showToast("You can only upload a maximum of 6 documents", "error");
      e.target.value = ""; // Clear the input
      return;
    }

    if (!files.length) return;

    // Check file sizes
    const oversizedFiles = files.filter((file) => file.size > 2 * 1024 * 1024); // 2MB in bytes
    if (oversizedFiles.length > 0) {
      showToast(
        "Some files exceed 2MB size limit. Please select smaller files.",
        "error"
      );
      e.target.value = ""; // Clear the input
      return;
    }

    const previews = files.map((file) => URL.createObjectURL(file));
    const updatedCarDocuments = [...formData.carDocuments, ...files];

    setFormData((prevData) => {
      const updatedData = {
        ...prevData,
        carDocuments: updatedCarDocuments,
      };

      // Validate here
      const newErrors = uploadCarValidation({
        ...updatedData,
        carDetails: { ...prevData.carDetails },
      });

      // ✅ Update errors
      setCarErrors((prevErrors) => ({
        ...prevErrors,
        carDocuments: newErrors.carDocuments || "",
      }));

      return updatedData;
    });

    // ✅ Explicitly mark as touched so red border logic activates
    setCarTouchedFields((prev) => ({
      ...prev,
      carDocuments: true,
    }));

    setImageCarDocuments((prevPreviews) => [...prevPreviews, ...previews]);
  };

  const handleCancelImages = (index) => {
    setFormData((prevData) => ({
      ...prevData,
      carImages: prevData.carImages.filter((_, i) => i !== index),
    }));
    setImagePreviews((prevPreviews) =>
      prevPreviews.filter((_, i) => i !== index)
    );
  };

  const handleCancelCarDocuments = (index) => {
    setFormData((prevData) => ({
      ...prevData,
      carDocuments: prevData.carDocuments.filter((_, i) => i !== index),
    }));
    setImageCarDocuments((prevPreviews) =>
      prevPreviews.filter((_, i) => i !== index)
    );
  };

  useEffect(() => {
    if (dealerData && user) {
      setFormData({
        ...formData,
        buyerFeeDetails: dealerData?.data?.buyerFeeDetails || "",
        dealershipName: dealerData?.data?.dealershipName || "",
        dealershipWebsite: dealerData?.data?.dealershipWebsite || "",
        vehicleSalesEachMonth: dealerData?.data?.vehicleSalesEachMonth || "",
        fullName: user?.username || "",
        phoneNumber: user?.phone || "",
        dealershipLicense: dealerData?.data?.dealershipLicense || null,
      });
    }
  }, [dealerData, user]);

  useEffect(() => {
    return () => {
      if (imagePreview) {
        URL.revokeObjectURL(imagePreview);
      }
    };
  }, [imagePreview]);

  return (
    <div className="">
      <div className="hidden lg:block sell-car">
        <div className="w-[15.5] flex flex-col pt-[20vh]">
          <div className="text-[2.6vw] font-semibold text-white">
            Upload Vehicle
          </div>
          <div className="text-white flex gap-3 justify-center text-[1vw] font-urbanist">
            <Link to="/">
              <button className="hover:text-white hover:scale-110 duration-150">
                Home
              </button>
            </Link>
            /
            <button className="hover:text-white hover:scale-110 duration-150">
              Upload Vehicle
            </button>
          </div>
        </div>
      </div>

      <div className="mt-[100px] lg:mt-[2vw] flex flex-col gap-y-2 items-center  justify-center w-[100vw]">
        <div className="flex flex-col items-start justify-center">
          <div className="flex justify-start font-urbanist text-[26px] lg:text-[2vw] font-bold ]">
            Sell Your Car
          </div>
          <hr className="h-[5px] bg-[#ca0000] mx-auto mt-[4px] w-[110px] " />
        </div>
      </div>

      <div className="pt-18  mx-auto w-[100vw] my-10">
        <form
          className="p-5 flex flex-col mx-auto max-w-[1000px] rounded-md shadow-[0px_4px_5px_6px_rgba(0,_0,_0,_0.1)] items-start gap-y-6"
          onSubmit={handleSubmit}
        >
          <h1 className="text-[30px] font-bold">Your Info</h1>
          <h1 className="text-[18px] font-bold mt-2">
            Deliever or private party?
          </h1>

          <div className="grid grid-cols-3 space-x-4 w-full">
            <button
              type="button"
              className={` border rounded-lg py-2 text-[#8A8AA0] flex justify-center items-center gap-x-2 ${
                userType === "dealer"
                  ? "bg-[#EEECFF] text-[#CA0000] font-bold"
                  : ""
              }`}
              onClick={() => setUserType("dealer")}
            >
              <FaTag />
              Dealer
            </button>
            <button
              type="button"
              className={` border bg-[#F8F8F8] text-[#8A8AA0] rounded-lg py-2 flex justify-center items-center gap-x-2 ${
                userType === "private"
                  ? "bg-[#EEECFF] text-[#CA0000] font-bold"
                  : ""
              }`}
              onClick={() => setUserType("private")}
            >
              <HiUserGroup />
              Private Party
            </button>
          </div>

          {userType === "dealer" && (
            <>
              <div className="grid w-full">
                <div className="flex flex-col items-start gap-y-2">
                  <label className="font-bold text-[18px]">
                    Are there any additional fees the buyer will have to pay?
                  </label>
                  <input
                    type="text"
                    name="buyerFeeDetails"
                    className={`${
                      dealerTouchedFields.buyerFeeDetails &&
                      dealerErrors.buyerFeeDetails
                        ? "border-[#CA0000] placeholder-[#CA0000]"
                        : ""
                    } border w-full py-2 px-4 rounded-lg`}
                    placeholder={`${
                      dealerTouchedFields.buyerFeeDetails &&
                      dealerErrors.buyerFeeDetails
                        ? dealerErrors.buyerFeeDetails
                        : "Write here.."
                    }`}
                    disabled={dealerData?.data.buyerFeeDetails ? true : false}
                    value={formData.buyerFeeDetails}
                    onChange={handleInputChange}
                  />
                  {dealerTouchedFields.buyerFeeDetails &&
                    dealerErrors.buyerFeeDetails && (
                      <p className="text-[#CA0000] text-sm mt-1">
                        {dealerErrors.buyerFeeDetails}
                      </p>
                    )}
                </div>
              </div>

              <div className="grid md:grid-cols-3 md:space-x-4 w-full">
                <div className="flex flex-col items-start gap-y-2">
                  <label className="font-bold text-[18px]">
                    Dealership Name
                  </label>
                  <input
                    type="text"
                    name="dealershipName"
                    placeholder={`${
                      dealerTouchedFields.dealershipName &&
                      dealerErrors.dealershipName
                        ? dealerErrors.dealershipName
                        : "Write here.."
                    }`}
                    className={`${
                      dealerTouchedFields.dealershipName &&
                      dealerErrors.dealershipName
                        ? "border-[#CA0000] placeholder-[#CA0000]"
                        : ""
                    } border w-full py-2 px-4 rounded-lg`}
                    disabled={dealerData?.data.dealershipName ? true : false}
                    value={formData.dealershipName}
                    onChange={handleInputChange}
                  />
                  {dealerTouchedFields.dealershipName &&
                    dealerErrors.dealershipName && (
                      <p className="text-[#CA0000] text-sm mt-1">
                        {dealerErrors.dealershipName}
                      </p>
                    )}
                </div>
                <div className="flex flex-col items-start gap-y-2 mt-4 md:mt-0">
                  <label className="font-bold text-[18px]">
                    Dealership Website
                  </label>
                  <input
                    type="text"
                    name="dealershipWebsite"
                    placeholder={`${
                      dealerTouchedFields.dealershipWebsite &&
                      dealerErrors.dealershipWebsite
                        ? dealerErrors.dealershipWebsite
                        : "Write here.."
                    }`}
                    className={`${
                      dealerTouchedFields.dealershipWebsite &&
                      dealerErrors.dealershipWebsite
                        ? "border-[#CA0000] placeholder-[#CA0000]"
                        : ""
                    } border w-full py-2 px-4 rounded-lg`}
                    value={formData.dealershipWebsite}
                    disabled={dealerData?.data.dealershipWebsite ? true : false}
                    onChange={handleInputChange}
                  />
                  {dealerTouchedFields.dealershipWebsite &&
                    dealerErrors.dealershipWebsite && (
                      <p className="text-[#CA0000] text-sm mt-1">
                        {dealerErrors.dealershipWebsite}
                      </p>
                    )}
                </div>
              </div>

              <div className="w-full">
                <div className="text-left mb-1">
                  <label className="font-bold text-[18px]">
                    How many vehicles does your dealership retail each month?
                  </label>
                </div>
                <div className="grid md:grid-cols-3 md:space-x-4">
                  <div className="w-full ">
                    <div className="relative w-full ">
                      <button
                        disabled={
                          dealerData?.data.vehicleSalesEachMonth ? true : false
                        }
                        type="button"
                        className={`border py-2 px-4 w-full text-left rounded-lg ${
                          dealerTouchedFields.vehicleSalesEachMonth &&
                          dealerErrors.vehicleSalesEachMonth
                            ? "border-[#CA0000] text-[#CA0000] placeholder-[#CA0000]"
                            : "text-black"
                        }`}
                        onClick={() => setIsOpen(!isOpen)}
                        onBlur={() => {
                          if (
                            !formData.vehicleSalesEachMonth ||
                            formData.vehicleSalesEachMonth ===
                              "Select sales range"
                          ) {
                            setDealerTouchedFields((prev) => ({
                              ...prev,
                              vehicleSalesEachMonth: true,
                            }));
                            validateDealerField(
                              "vehicleSalesEachMonth",
                              formData.vehicleSalesEachMonth
                            );
                          }
                        }}
                      >
                        {formData.vehicleSalesEachMonth || "Select sales range"}
                      </button>

                      {isOpen && (
                        <div className="absolute z-10 w-full bg-white border border-gray-300 mt-1 rounded-md shadow-lg">
                          {options.map((option) => (
                            <div
                              key={option}
                              className="p-2 hover:bg-gray-180 cursor-pointer text-left"
                              onClick={() => handleOptionClick(option)}
                            >
                              {option}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* ===============================  IMAGE  ========================================= */}

              <div className="flex flex-col items-start gap-y-4">
                <label className="font-bold text-[18px]">
                  Please upload a photo of your dealer license.
                </label>

                <h5 className="text-gray-500 text-left">
                  *This information will be kept private and only used for
                  verification. It will not be shown in the auction listing.
                </h5>
              </div>
              <div className="flex items-center justify-center w-full ">
                <label
                  htmlFor="dropzone-file"
                  className={`flex items-center justify-between w-full py-8 px-6 border-2 rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 ${
                    dealerErrors.dealershipLicense
                      ? "border-[#CA0000]"
                      : "border-gray-300"
                  }`}
                >
                  {formData.dealershipLicense || imagePreview ? (
                    <div className="flex justify-between w-full items-center">
                      <img
                        src={imagePreview || formData.dealershipLicense}
                        alt="Uploaded preview"
                        style={{ width: "80px", height: "auto" }}
                      />
                      {!formData.dealershipLicense && (
                        <button
                          type="button"
                          onClick={handleCancelImage}
                          className="border rounded-full bg-red-180 font-bold text-[#CA0000] py-2 px-4 mt-2"
                        >
                          Cancel
                        </button>
                      )}
                    </div>
                  ) : (
                    <div className="flex flex-col items-center justify-center">
                      <p className="text-gray-500">
                        PNG, JPG, JPEG or WEBP. Max 180mb
                      </p>
                    </div>
                  )}
                  <input
                    id="dropzone-file"
                    name="dealershipLicense"
                    type="file"
                    disabled={formData.dealershipLicense ? true : false}
                    className="hidden"
                    onChange={handleFileChange}
                    ref={fileInputRef}
                  />
                  {!imagePreview && !formData.dealershipLicense && (
                    <button
                      type="button"
                      disabled={formData.dealershipLicense ? true : false}
                      onClick={handleUploadClick}
                      className="border rounded-full bg-[#EEECFF] font-bold text-[#CA0000] py-2 px-4"
                    >
                      Upload file
                    </button>
                  )}
                </label>
              </div>
              {dealerErrors.dealershipLicense && (
                <p className="text-[#CA0000] text-sm mt-1">
                  {dealerErrors.dealershipLicense}
                </p>
              )}
            </>
          )}
          {(userType === "private" || userType === "dealer") && (
            <div className="w-full">
              <div className="grid md:grid-cols-3 md:space-x-4">
                <div className="flex flex-col items-start gap-y-2">
                  <label className="font-bold text-[18px]">Full Name</label>
                  <input
                    type="text"
                    disabled
                    name="fullName"
                    placeholder="Write here..."
                    className="border py-2 px-4 text-gray-500 w-full rounded-lg cursor-not-allowed"
                    value={formData.fullName}
                  />
                </div>
                <div className="flex flex-col items-start gap-y-2 mt-4 md:mt-0">
                  <label className="font-bold text-[18px]">
                    Contact Phone Number
                  </label>
                  <PhoneInput
                    disabled
                    country={"us"}
                    countryCodeEditable={false}
                    disableDropdown={true}
                    buttonStyle={{
                      background: "white",
                      borderRight: "0px",
                    }}
                    value={formData.phoneNumber}
                    containerClass=" mx-auto border-none  outline-none  m-0 "
                    inputStyle={{
                      width: "100%",
                      paddingTop: "10px",
                      color: "gray",
                      // backgroundColor: "red",
                      height: "40px",
                    }}
                    inputClass="bg-blue-400 text-black p-2 m-0 border-none rounded outline-none focus:outline-none "
                  />
                </div>
              </div>
            </div>
          )}

          {/* =================================== CAR Details ======================================== */}
          <div className="w-full flex flex-col gap-y-4">
            <h1 className="text-[30px] font-bold text-left mt-8 ">
              Car details
            </h1>

            {/* VIN  */}
            <div className="grid md:grid-cols-3 ">
              <div className="flex flex-col items-start gap-y-2 mt-6 w-full">
                <label className="font-bold text-[18px]">VIN*</label>
                <input
                  type="text"
                  name="vin"
                  placeholder="Write here.."
                  className={`border py-2 px-4 rounded-lg w-full ${
                    carTouchedFields.vin && carErrors.vin
                      ? "border-[#CA0000]"
                      : ""
                  }`}
                  value={formData.carDetails.vin}
                  onChange={handleCarDetailsChange}
                />
                {carTouchedFields.vin && carErrors.vin && (
                  <p className="text-[#CA0000] text-sm mt-1">{carErrors.vin}</p>
                )}
              </div>
            </div>

            {showAdditionalAfterVinFields && (
              <>
                {/* Year, Make, Model */}
                <div className="grid md:grid-cols-3 md:space-x-4">
                  <div className="flex flex-col items-start gap-y-2">
                    <label className="font-bold text-[18px]">Year*</label>
                    <input
                      type="text"
                      name="year"
                      placeholder={`${carTouchedFields.year && carErrors.year ? carErrors.year : "Write here.."}`}
                      className={`border py-2 px-4 rounded-lg w-full ${
                        carTouchedFields.year && carErrors.year
                          ? "placeholder-[#CA0000] border-[#CA0000]"
                          : ""
                      }`}
                      value={formData.carDetails.year}
                      onChange={handleCarDetailsChange}
                    />
                    {carTouchedFields.year && carErrors.year && (
                      <p className="text-[#CA0000] text-sm mt-1">
                        {carErrors.year}
                      </p>
                    )}
                  </div>
                  <div className="flex flex-col items-start gap-y-2 mt-4 md:mt-0">
                    <label className="font-bold text-[18px]">Make*</label>
                    <input
                      type="text"
                      name="make"
                      placeholder={`${carTouchedFields.make && carErrors.make ? carErrors.make : "Write here.."}`}
                      className={`border py-2 px-4 rounded-lg w-full ${
                        carTouchedFields.make && carErrors.make
                          ? "placeholder-[#CA0000] border-[#CA0000]"
                          : ""
                      }`}
                      value={formData.carDetails.make}
                      onChange={handleCarDetailsChange}
                    />
                    {carTouchedFields.make && carErrors.make && (
                      <p className="text-[#CA0000] text-sm mt-1">
                        {carErrors.make}
                      </p>
                    )}
                  </div>
                  <div className="flex flex-col items-start mt-4 md:mt-0 gap-y-2">
                    <label className="font-bold text-[18px]">Model*</label>
                    <input
                      type="text"
                      name="model"
                      placeholder={`${carTouchedFields.model && carErrors.model ? carErrors.model : "Write here.."}`}
                      className={`border py-2 px-4 rounded-lg w-full ${
                        carTouchedFields.model && carErrors.model
                          ? "placeholder-[#CA0000] border-[#CA0000]"
                          : ""
                      }`}
                      value={formData.carDetails.model}
                      onChange={handleCarDetailsChange}
                    />
                    {carTouchedFields.model && carErrors.model && (
                      <p className="text-[#CA0000] text-sm mt-1">
                        {carErrors.model}
                      </p>
                    )}
                  </div>
                </div>

                {/* Transmissions, Mileage */}
                <div className="grid md:grid-cols-3 md:space-x-4">
                  <div className="flex flex-col items-start gap-y-2">
                    <label className="font-bold text-[18px]">
                      Transmission*
                    </label>
                    <div className="relative w-full ">
                      <button
                        type="button"
                        className={`${
                          carErrors.transmission
                            ? "placeholder-[#CA0000]  border-[#CA0000]  text-[#CA0000] "
                            : "text-black"
                        }  border py-2 px-4 rounded-lg w-full  text-left`}
                        onClick={() =>
                          setTransmissionIsOpen(!transmissionIsOpen)
                        }
                      >
                        {transmission}
                      </button>
                      {transmissionIsOpen && (
                        <div className="absolute z-10 w-full bg-white border border-gray-300 mt-1 rounded-md shadow-lg">
                          {transmissionOptions.map((option) => (
                            <div
                              key={option}
                              className="p-2 hover:bg-gray-180 cursor-pointer text-left"
                              onClick={() =>
                                handleTransmissionOptionClick(option)
                              }
                            >
                              {option}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                    {carTouchedFields.transmission &&
                      carErrors.transmission && (
                        <p className="text-[#CA0000] text-sm mt-1">
                          {carErrors.transmission}
                        </p>
                      )}
                  </div>
                  <div className="flex flex-col items-start mt-4 md:mt-0 gap-y-2">
                    <label className="font-bold text-[18px]">
                      Millage (miles)*
                    </label>
                    {/* <input
                      type="text"
                      name="mileage"
                      placeholder={`${carTouchedFields.mileage && carErrors.mileage ? carErrors.mileage : "Write here.."}`}
                      className={`border py-2 px-4 rounded-lg w-full ${
                        carTouchedFields.mileage && carErrors.mileage
                          ? "placeholder-[#CA0000] border-[#CA0000]"
                          : ""
                      }`}
                      value={formData.carDetails.mileage}
                      onChange={handleCarDetailsChange}
                    /> */}
                    <CurrencyInput
                      name="mileage"
                      prefix=""
                      className={`border py-2 px-4 rounded-lg w-full ${
                        carTouchedFields.mileage && carErrors.mileage
                          ? "placeholder-[#CA0000] border-[#CA0000]"
                          : ""
                      }`}
                      decimalsLimit={0}
                      value={formData.carDetails.mileage}
                      onValueChange={(value) => {
                        handleCarDetailsChange({
                          target: { name: "mileage", value },
                        });
                      }}
                    />

                    {carTouchedFields.mileage && carErrors.mileage && (
                      <p className="text-[#CA0000] text-sm mt-1">
                        {carErrors.mileage}
                      </p>
                    )}
                  </div>
                </div>
              </>
            )}

            {/* Select option Equipment */}
            <div className="grid grid-cols-1 space-x-4">
              <div className="flex flex-col items-start gap-y-2 mt-2">
                <label className="font-bold text-[18px]">
                  Select option/equipment
                </label>
                <input
                  type="text"
                  name="description"
                  placeholder={`${
                    carErrors.description
                      ? carErrors.description
                      : "For example: sport package, lon range battery, FSD or other important factory installed features"
                  } `}
                  className={`border py-8 px-4 rounded-lg w-full ${
                    carErrors.description
                      ? "placeholder-[#CA0000]  border-[#CA0000] "
                      : ""
                  }`}
                  value={formData.carDetails.description}
                  onChange={handleCarDetailsChange}
                />
                {carTouchedFields.description && carErrors.description && (
                  <p className="text-[#CA0000] text-sm mt-1">
                    {carErrors.description}
                  </p>
                )}
              </div>
            </div>
          </div>

          {/* toggle  --> Car Modification Status */}
          <div className="flex flex-col items-start w-full gap-4">
            <label className="font-bold text-[18px]">
              Has the car been modified?
            </label>
            <div className="flex flex-col items-start gap-y-2">
              <div className="flex justify-center items-center gap-x-4">
                <input
                  type="radio"
                  id="stock"
                  name="carModificationStatus"
                  class="radio radio-error"
                  checked={carModificationStatus === "stock"}
                  onChange={() => setCarModificationStatus("stock")}
                />
                <label htmlFor="stock">Completely Stock</label>
              </div>

              <div className="flex justify-center items-center gap-x-4">
                <input
                  type="radio"
                  id="modified"
                  name="carModificationStatus"
                  class="radio radio-error"
                  value="modified"
                  checked={carModificationStatus === "modified"}
                  onChange={() => setCarModificationStatus("modified")}
                />
                <label htmlFor="modified">Modified</label>
              </div>
            </div>
            {carModificationStatus === "modified" && (
              <div className="grid grid-cols-1 w-full">
                <div className="flex flex-col items-start justify-start gap-y-2 mt-2">
                  <label htmlFor="" className="font-bold text-left">
                    List any modifications, including modifications or removal
                    of catalytic converters*
                  </label>
                  <textarea
                    name="modification"
                    className={` border w-full py-2 px-4 rounded-lg mt-2`}
                    placeholder="Describe the modifications..."
                    required={
                      carModificationStatus === "modified" ? true : false
                    }
                    rows={4}
                    value={formData.carDetails.modification}
                    onChange={handleCarDetailsChange}
                  />
                </div>
              </div>
            )}
          </div>

          {/* toggle  --> significant changes */}
          <div className="flex flex-col items-start gap-y-4">
            <label className="font-bold text-[18px] text-left">
              Are there any significant mechanical or cosmetic flaws that we
              should know about?
            </label>
            <div className="flex gap-x-3">
              <input
                type="checkbox"
                className={`toggle  ${
                  selectedOptions.significantFlaws
                    ? "[--tglbg:#CA0000] bg-white hover:bg-white"
                    : "[--tglbg:white] bg-[#EEECFF] hover:bg-[#EEECFF]"
                }`}
                checked={selectedOptions.significantFlaws}
                onChange={() => handleToggleChange("significantFlaws")}
              />
              {selectedOptions.significantFlaws ? "Yes" : "No"}
            </div>
          </div>

          {selectedOptions.significantFlaws && (
            <div className="grid grid-cols-1 w-full">
              <div className="flex flex-col items-start ">
                <input
                  type="text"
                  name="significantFlaws"
                  placeholder={`Please give details... `}
                  className={`border py-6 px-4 rounded-lg w-full ${
                    carErrors.significantFlaws
                      ? "placeholder-[#CA0000]  border-[#CA0000] "
                      : ""
                  }`}
                  required={selectedOptions.significantFlaws ? true : false}
                  value={formData.carDetails.significantFlaws}
                  onChange={handleCarDetailsChange}
                  disabled={!selectedOptions.significantFlaws}
                />
              </div>
            </div>
          )}

          {/*dropdown --> Car located */}
          {/* <div className="grid md:grid-cols-3  md:gap-x-4 w-full">
            <div className="flex flex-col items-start gap-y-2 mt-2 w-full">
              <label className="font-bold text-[18px] text-left">
                Where is the car located?*
              </label>
              <Select
                value={option.find(
                  (opt) => opt.label === formData.carDetails.carLocation
                )}
                options={option}
                styles={customStyles}
                onChange={(selectedOption) => {
                  const value = selectedOption ? selectedOption.label : "";
                  setCountry(value);
                  setFormData((prev) => ({
                    ...prev,
                    carDetails: {
                      ...prev.carDetails,
                      carLocation: value,
                      carState: "",
                    },
                  }));
                  setCarTouchedFields((prev) => ({
                    ...prev,
                    carLocation: true,
                  }));
                  validateCarField("carLocation", value);
                }}
                onBlur={() => {
                  setCarTouchedFields((prev) => ({
                    ...prev,
                    carLocation: true,
                  }));
                  validateCarField(
                    "carLocation",
                    formData.carDetails.carLocation
                  );
                }}
                className={`w-full ${
                  carTouchedFields.carLocation && carErrors.carLocation
                    ? "border border-[#CA0000]"
                    : ""
                }`}
              />
              {carTouchedFields.carLocation && carErrors.carLocation && (
                <p className="text-[#CA0000] text-sm mt-1">
                  {carErrors.carLocation}
                </p>
              )}
            </div>
            {country && (
              <div className="flex flex-col items-start gap-y-2 mt-2 w-full">
                <label className="font-bold text-[18px] text-left">
                  Select Island*
                </label>

                <RegionDropdown
                  country={country}
                  defaultOptionLabel="Select Island"
                  value={region}
                  onChange={(val) => {
                    setRegion(val);
                    setFormData((prev) => ({
                      ...prev,
                      carDetails: {
                        ...prev.carDetails,
                        carState: val,
                      },
                    }));
                    setCarTouchedFields((prev) => ({
                      ...prev,
                      carState: true,
                    }));
                    validateCarField("carState", val);
                  }}
                  onBlur={() => {
                    setCarTouchedFields((prev) => ({
                      ...prev,
                      carState: true,
                    }));
                    validateCarField("carState", region || "");
                  }}
                  className={`w-full h-[42px] border-2 rounded-md px-2 ${
                    carTouchedFields.carState && carErrors.carState
                      ? "border-[#CA0000]"
                      : "border-gray-300"
                  }`}
                     placeholder="Select Island"
                  
                />

                {carTouchedFields.carState && carErrors.carState && (
                  <p className="text-[#CA0000] text-sm mt-1">
                    {carErrors.carState}
                  </p>
                )}
              </div>
            )}
          </div> */}


   {/*dropdown --> Car titled AT -  */}
   <div className="grid gap-4 md:grid-cols-3 w-full">
            <div className="flex flex-col items-start gap-y-2 mt-2 w-full">
              <label className="font-bold text-[18px]">
                Where is the car located?*
              </label>
              <Select
                value={carTitledOptions.find(
                  (opt) => opt.label === formData.carDetails.carLocation
                )}
                options={carTitledOptions}
                styles={customStyles}
                onChange={(selectedOption) => {
                  const value = selectedOption ? selectedOption.label : "";
                  setFormData((prev) => ({
                    ...prev,
                    carDetails: { ...prev.carDetails, carLocation: value },
                  }));
                  setCarTouchedFields((prev) => ({
                    ...prev,
                    carLocation: true,
                  }));
                  validateCarField("carLocation", value);
                }}
                onBlur={() => {
                  setCarTouchedFields((prev) => ({
                    ...prev,
                    carLocation: true,
                  }));
                  validateCarField(
                    "carLocation",
                    formData.carDetails.carLocation
                  );
                }}
                className={`w-full ${
                  carTouchedFields.carLocation && carErrors.carLocation
                    ? "border border-[#CA0000]"
                    : ""
                }`}
              />
              {carTouchedFields.carLocation && carErrors.carLocation && (
                <p className="text-[#CA0000] text-sm mt-1">
                  {carErrors.carLocation}
                </p>
              )}
            </div>

            {formData.carDetails.carLocation === "Bahamas" && (
              <div className="flex flex-col items-start gap-y-2 mt-2 w-full">
                <label className="font-bold text-[18px]">Select Island*</label>
                <Select
                  value={bahamasStates.find(
                    (opt) => opt.label === formData.carDetails.carState
                  )}
                  options={bahamasStates}
                  styles={customStyles}
                  onChange={(selectedOption) => {
                    const value = selectedOption ? selectedOption.label : "";
                    setFormData((prevData) => ({
                      ...prevData,
                      carDetails: {
                        ...prevData.carDetails,
                        carState: value,
                      },
                    }));
                    setCarTouchedFields((prev) => ({
                      ...prev,
                      carState: true,
                    }));
                    validateCarField("carState", value);
                  }}
                  onBlur={() => {
                    setCarTouchedFields((prev) => ({
                      ...prev,
                      carState: true,
                    }));
                    validateCarField(
                      "carState",
                      formData.carDetails.carState || ""
                    );
                  }}
                  className={`w-full ${
                    carTouchedFields.carState && carErrors.carState
                      ? "border border-[#CA0000]"
                      : ""
                  }`}
                  placeholder="Select Island"
                />
                {carTouchedFields.carState && carErrors.carState && (
                  <p className="text-[#CA0000] text-sm mt-1">
                    {carErrors.carState}
                  </p>
                )}
              </div>
            )}
          </div>




          {/* Postal code  */}
          <div className="grid md:grid-cols-3 w-full">
            <div className="flex flex-col items-start gap-y-2 mt-6 w-full">
              <label className="font-bold text-[18px]">Postal code</label>
              <input
                type="text"
                name="zip"
                maxLength={10}
                placeholder={`${carTouchedFields.zip && carErrors.zip ? carErrors.zip : "Write here.."}`}
                className={`border py-2 px-4 rounded-lg w-full ${
                  carTouchedFields.zip && carErrors.zip
                    ? "placeholder-[#CA0000] border-[#CA0000]"
                    : ""
                }`}
                value={formData.carDetails.zip}
                onChange={handleCarDetailsChange}
              />
              {carTouchedFields.zip && carErrors.zip && (
                <p className="text-[#CA0000] text-sm mt-1">{carErrors.zip}</p>
              )}
            </div>
          </div>

          {/* Toggle => Car for sale  |  add more +  */}
          <div className="grid md:grid-cols-3 w-full">
            <div className="flex flex-col gap-y-4 items-start">
              <label className="flex items-center text-left font-bold text-[18px]">
                Is the car for sale elsewhere?
              </label>
              <div className="flex gap-x-3">
                <input
                  type="checkbox"
                  className={`toggle  ${
                    selectedOptions.isCarForSale
                      ? "[--tglbg:#CA0000] bg-white hover:bg-white"
                      : "[--tglbg:white] bg-[#EEECFF] hover:bg-[#EEECFF]"
                  }`}
                  checked={selectedOptions.isCarForSale}
                  onChange={() => handleToggleChange("isCarForSale")}
                />
                {selectedOptions.isCarForSale ? "Yes" : "No"}
              </div>
            </div>
          </div>

          {selectedOptions.isCarForSale && (
            <div className="grid grid-cols-1 w-full">
              <div className="flex flex-col items-start gap-y-2 w-full">
                <label className="text-gray-500 text-center">
                  *If we accept your car all other listings will be need to
                  taken down before it can be listed on our site.*
                </label>
                <div className="flex flex-col items-start gap-y-2 mt-4 w-full">
                  {additionalFields.map((field, index) => (
                    <input
                      key={index}
                      type="text"
                      required={selectedOptions.isCarForSale}
                      value={field}
                      onChange={(e) => handleAdditionalFieldChange(index, e)}
                      className="border mb-2 py-2 px-4 w-full"
                      placeholder="Link here.."
                    />
                  ))}
                  <button
                    type="button"
                    onClick={handleAddMoreFields}
                    className="font-bold text-[#CA0000] "
                  >
                    Add More +
                  </button>
                </div>
              </div>
            </div>
          )}

          {/*=========================== TITLE INFO ===========================*/}
          <h1 className="text-3xl font-bold text-left mt-8 text-[30px]">
            Title Info
          </h1>

          {/*dropdown --> Car titled AT -  */}
          <div className="grid gap-4 md:grid-cols-3 w-full">
            <div className="flex flex-col items-start gap-y-2 mt-2 w-full">
              <label className="font-bold text-[18px]">
                Where is the car titled?*
              </label>
              <Select
                value={carTitledOptions.find(
                  (opt) => opt.label === formData.carDetails.carTitledAt
                )}
                options={carTitledOptions}
                styles={customStyles}
                onChange={(selectedOption) => {
                  const value = selectedOption ? selectedOption.label : "";
                  setFormData((prev) => ({
                    ...prev,
                    carDetails: { ...prev.carDetails, carTitledAt: value },
                  }));
                  setCarTouchedFields((prev) => ({
                    ...prev,
                    carTitledAt: true,
                  }));
                  validateCarField("carTitledAt", value);
                }}
                onBlur={() => {
                  setCarTouchedFields((prev) => ({
                    ...prev,
                    carTitledAt: true,
                  }));
                  validateCarField(
                    "carTitledAt",
                    formData.carDetails.carTitledAt
                  );
                }}
                className={`w-full ${
                  carTouchedFields.carTitledAt && carErrors.carTitledAt
                    ? "border border-[#CA0000]"
                    : ""
                }`}
              />
              {carTouchedFields.carTitledAt && carErrors.carTitledAt && (
                <p className="text-[#CA0000] text-sm mt-1">
                  {carErrors.carTitledAt}
                </p>
              )}
            </div>

            {formData.carDetails.carTitledAt === "Bahamas" && (
              <div className="flex flex-col items-start gap-y-2 mt-2 w-full">
                <label className="font-bold text-[18px]">Select Island*</label>
                <Select
                  value={bahamasStates.find(
                    (opt) => opt.label === formData.carDetails.bahamasState
                  )}
                  options={bahamasStates}
                  styles={customStyles}
                  onChange={(selectedOption) => {
                    const value = selectedOption ? selectedOption.label : "";
                    setFormData((prevData) => ({
                      ...prevData,
                      carDetails: {
                        ...prevData.carDetails,
                        bahamasState: value,
                      },
                    }));
                    setCarTouchedFields((prev) => ({
                      ...prev,
                      bahamasState: true,
                    }));
                    validateCarField("bahamasState", value);
                  }}
                  onBlur={() => {
                    setCarTouchedFields((prev) => ({
                      ...prev,
                      bahamasState: true,
                    }));
                    validateCarField(
                      "bahamasState",
                      formData.carDetails.bahamasState || ""
                    );
                  }}
                  className={`w-full ${
                    carTouchedFields.bahamasState && carErrors.bahamasState
                      ? "border border-[#CA0000]"
                      : ""
                  }`}
                  placeholder="Select Island"
                />
                {carTouchedFields.bahamasState && carErrors.bahamasState && (
                  <p className="text-[#CA0000] text-sm mt-1">
                    {carErrors.bahamasState}
                  </p>
                )}
              </div>
            )}
          </div>


          {/* Toggle => Vechicle titled info  */}
          <div className="grid md:grid-cols-3 w-full  ">
            <div className="flex flex-col gap-y-4">
              <label className="text-left font-bold text-[18px]">
                Is the vehicle titled in your name?
              </label>
              <div className="flex gap-x-3">
                <input
                  type="checkbox"
                  className={`toggle  ${
                    selectedOptions.carTitledInfo
                      ? "[--tglbg:#CA0000] bg-white hover:bg-white"
                      : "[--tglbg:white] bg-[#EEECFF] hover:bg-[#EEECFF]"
                  }`}
                  checked={selectedOptions.carTitledInfo}
                  onChange={() => handleToggleChange("carTitledInfo")}
                />
                {selectedOptions.carTitledInfo ? "Yes" : "No"}
              </div>
            </div>
          </div>
          {!selectedOptions.carTitledInfo && (
            <p className="text-gray-500 text-left">
              if the vehicle is titled or registered in the name of another
              individual, a photo of the person's ID will be requested for
              furthor verification.
            </p>
          )}

          {!selectedOptions.carTitledInfo && (
            <div className="grid grid-cols-1 w-full">
              <div className="flex flex-col gap-y-4 items-start ">
                <label className="font-bold text-[18px] text-left">
                  Whose name is on the title? What's your relationship with
                  them?*
                </label>
                <input
                  type="text"
                  name="carTitledInfo"
                  placeholder={
                    carTouchedFields.carTitledInfo && carErrors.carTitledInfo
                      ? carErrors.carTitledInfo
                      : "Write here..."
                  }
                  required
                  className={`border py-6 px-4 rounded-lg w-full ${
                    carTouchedFields.carTitledInfo && carErrors.carTitledInfo
                      ? "placeholder-[#CA0000] border-[#CA0000]"
                      : ""
                  }`}
                  value={formData.carDetails.carTitledInfo}
                  onChange={handleCarDetailsChange}
                  onBlur={() => {
                    setCarTouchedFields((prev) => ({
                      ...prev,
                      carTitledInfo: true,
                    }));
                    validateCarField(
                      "carTitledInfo",
                      formData.carDetails.carTitledInfo
                    );
                  }}
                />
              </div>
            </div>
          )}

          {/*dropdown --> Car status */}
          <div className="grid md:grid-cols-3 w-full">
            <div className="flex flex-col items-start gap-y-2 mt-2 w-full">
              <label className="font-bold text-[18px] text-left">
                What is the Drivability status?*
              </label>
              <Select
                value={titleStatusOptions.find(
                  (opt) => opt.label === formData.carDetails.titlesStatus
                )}
                options={titleStatusOptions}
                styles={customStyles}
                onChange={(selectedOption) => {
                  const value = selectedOption ? selectedOption.label : "";
                  setFormData((prev) => ({
                    ...prev,
                    carDetails: { ...prev.carDetails, titlesStatus: value },
                  }));
                  setCarTouchedFields((prev) => ({
                    ...prev,
                    titlesStatus: true,
                  }));
                  validateCarField("titlesStatus", value);
                }}
                onBlur={() => {
                  setCarTouchedFields((prev) => ({
                    ...prev,
                    titlesStatus: true,
                  }));
                  validateCarField(
                    "titlesStatus",
                    formData.carDetails.titlesStatus
                  );
                }}
                className={`w-full ${
                  carTouchedFields.titlesStatus && carErrors.titlesStatus
                    ? "border border-[#CA0000]"
                    : ""
                }`}
              />
              {carTouchedFields.titlesStatus && carErrors.titlesStatus && (
                <p className="text-[#CA0000] text-sm mt-1">
                  {carErrors.titlesStatus}
                </p>
              )}
            </div>
          </div>

          {/*=========================== Reserve Price ===========================*/}
          <h1 className="text-3xl font-bold text-left mt-8 text-[30px]">
            Reserve Price
          </h1>

          {/* Toggle => Reserve price  */}
          <div className="grid grid-cols-1 w-full  ">
            <div className="flex flex-col gap-y-4">
              <label className="text-left font-bold text-[18px]">
                Do you want to set a minimum price required for your vehicle to
                sell?
              </label>
              <div className="flex gap-x-3">
                <input
                  type="checkbox"
                  className={`toggle  ${
                    selectedOptions.minPrice
                      ? "[--tglbg:#CA0000] bg-white hover:bg-white"
                      : "[--tglbg:white] bg-[#EEECFF] hover:bg-[#EEECFF]"
                  }`}
                  checked={selectedOptions.minPrice}
                  onChange={() => handleToggleChange("minPrice")}
                />
                {selectedOptions.minPrice ? "Yes" : "No"}
              </div>
            </div>
          </div>
          {selectedOptions.minPrice && (
            <div className="grid md:grid-cols-3 w-full">
              <div className="flex flex-col gap-y-4 items-start ">
                <label className="font-bold text-[18px] text-left">
                  What reserve price would you like?*
                </label>
                <CurrencyInput
                  id="input-example"
                  name="minPrice"
                  // placeholder="Price in USD"
                  prefix="$"
                  className={`border py-2 px-4 rounded-lg w-full `}
                  defaultValue={0}
                  decimalsLimit={2}
                  required={selectedOptions.minPrice ? true : false}
                  value={formData.carDetails.minPrice}
                  onValueChange={(value) => handleMinPriceChange(value)}
                />
              </div>
            </div>
          )}

          {/*=========================== Buy Now Price ===========================*/}
          <h1 className="text-3xl font-bold text-left mt-8 text-[30px]">
            Buy Now Price
          </h1>

          {/* Toggle => Buy Now Price  */}
          <div className="grid grid-cols-1 w-full  ">
            <div className="flex flex-col gap-y-4">
              <label className="text-left font-bold text-[18px]">
                Do you want to set a buy now price for your vehicle?
              </label>
              <div className="flex gap-x-3">
                <input
                  type="checkbox"
                  className={`toggle  ${
                    selectedOptions.buyNowPrice
                      ? "[--tglbg:#CA0000] bg-white hover:bg-white"
                      : "[--tglbg:white] bg-[#EEECFF] hover:bg-[#EEECFF]"
                  }`}
                  checked={selectedOptions.buyNowPrice}
                  onChange={() => handleToggleChange("buyNowPrice")}
                />
                {selectedOptions.buyNowPrice ? "Yes" : "No"}
              </div>
            </div>
          </div>

          {selectedOptions.buyNowPrice && (
            <div className="grid md:grid-cols-3 w-full">
              <div className="flex flex-col gap-y-4 items-start ">
                <label className="font-bold text-[18px] text-left">
                  What buy now price would you like?*
                </label>
                <CurrencyInput
                  id="input-example"
                  name="buyNowPrice"
                  // placeholder="Price in USD"
                  prefix="$"
                  className={`border py-2 px-4 rounded-lg w-full ${
                    buyNowPriceError ? "border-[#CA0000]" : ""
                  }`}
                  defaultValue={0}
                  decimalsLimit={2}
                  required={selectedOptions.buyNowPrice ? true : false}
                  value={formData.carDetails.buyNowPrice}
                  onValueChange={(value) => handleBuyNowPriceChange(value)}
                />
                {carTouchedFields.buyNowPrice && carErrors.buyNowPrice && (
                  <p className="text-[#CA0000] text-sm mt-1">
                    {carErrors.buyNowPrice}
                  </p>
                )}
                {buyNowPriceError && (
                  <p className="text-[#CA0000] text-sm mt-1">
                    {buyNowPriceError}
                  </p>
                )}
              </div>
            </div>
          )}

          {/*================================ mul images ============================ */}
          <h1 className="text-[30px] font-bold text-left mt-8">Photos</h1>

          <div className="flex flex-col items-start gap-y-4">
            <label className="font-bold text-[18px]">
              Please upload maximum 6 photos of the exterior & interior of the
              car.*
            </label>
            <h5 className="text-gray-500 text-left">
              *To learn more check our photo guide.
            </h5>
          </div>

          {/* ✅ Preview Section */}
          <div className="flex items-center justify-start w-full flex-wrap gap-4">
            {imagePreviews.map((preview, index) => (
              <div key={index} className="relative">
                <img
                  src={preview}
                  alt={`Uploaded preview ${index + 1}`}
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "10px",
                  }}
                />
                <MdCancel
                  type="button"
                  onClick={() => handleCancelImages(index)}
                  className="absolute text-[20px] top-0 right-0 border rounded-full bg-red-180 font-bold text-[#CA0000]"
                />
              </div>
            ))}
          </div>

          {/* ✅ Upload Input With Border Validation */}
          <div className="flex items-center justify-center w-full mt-4">
            <label
              htmlFor="dropzone-files"
              className={`flex items-center justify-between w-full py-8 px-6 border-2 rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 ${
                carTouchedFields.carImages && carErrors.carImages
                  ? "border-[#CA0000]"
                  : "border-gray-300"
              }`}
            >
              <div className="flex flex-col items-start justify-center">
                <p className="text-gray-500">
                  PNG, JPG, JPEG or WEBP. Max Size for one image is 2mb
                </p>
              </div>
              <input
                id="dropzone-files"
                name="carImages"
                type="file"
                accept="image/png, image/jpeg, image/webp"
                multiple
                className="hidden"
                onChange={handleFileChanges}
                ref={filesInputRef}
              />
              <button
                type="button"
                onClick={handleUploadClicks}
                className="border rounded-full bg-[#EEECFF] font-bold text-[#CA0000] py-2 px-4"
              >
                Upload files
              </button>
            </label>
          </div>

          {/* ✅ Error Message */}
          {carTouchedFields.carImages && carErrors.carImages && (
            <p className="text-[#CA0000] text-sm mt-1">{carErrors.carImages}</p>
          )}

          {/* Documents images */}

          <div className="flex flex-col items-start gap-y-4">
            <label className="font-bold text-[18px]">
              Please upload at maximum 6 photos of Your documents.*
            </label>
            <h5 className="text-gray-500 text-left">
              *To learn more check our photo guide.
            </h5>
          </div>

          {/* ✅ Image Preview Grid */}
          <div className="flex items-center justify-start w-full flex-wrap gap-x-4">
            {imageCarDocuments.map((preview, index) => (
              <div key={index} className="relative">
                <img
                  src={preview}
                  alt={`Uploaded preview ${index + 1}`}
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "10px",
                  }}
                />
                <MdCancel
                  type="button"
                  onClick={() => handleCancelCarDocuments(index)}
                  className="absolute text-[20px] top-0 right-0 border rounded-full bg-red-180 font-bold text-[#CA0000]"
                />
              </div>
            ))}
          </div>

          {/* ✅ Upload Input with Validation Border */}
          <div className="flex items-center justify-center w-full mt-4">
            <label
              htmlFor="dropzone-files-car-documents"
              className={`flex items-center justify-between w-full py-8 px-6 border-2 rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 ${
                carTouchedFields.carDocuments && carErrors.carDocuments
                  ? "border-[#CA0000]"
                  : "border-gray-300"
              }`}
            >
              <div className="flex flex-col items-center justify-center">
                <p className="text-gray-500">
                  PNG, JPG, JPEG or WEBP. Max Size for one image is 2mb.
                </p>
              </div>

              <input
                id="dropzone-files-car-documents"
                name="carDocuments"
                type="file"
                multiple
                accept="image/png, image/jpeg, image/webp"
                className="hidden"
                onChange={handleFileChangesCarDocuments}
                ref={filesCarDocumentsRef}
              />

              <button
                type="button"
                onClick={handleUploadClicksCarDocuments}
                className="border rounded-full bg-[#EEECFF] font-bold text-[#CA0000] py-2 px-4"
              >
                Upload files
              </button>
            </label>
          </div>

          {/* ✅ Error Message */}
          {carTouchedFields.carDocuments && carErrors.carDocuments && (
            <p className="text-[#CA0000] text-sm mt-1">
              {carErrors.carDocuments}
            </p>
          )}

          {/*===========================  Referral ===========================*/}
          <h1 className="text-[30px] font-bold text-left mt-8">Referral</h1>
          <div className="grid grid-cols-1 w-full">
            <div className="flex flex-col gap-y-4 items-start ">
              <label className="font-bold text-[18px] text-left">
                How did you hear about us? if a user referred us, please mention
                their username.
              </label>
              <input
                type="text"
                name="referral"
                placeholder={`${carTouchedFields.referral && carErrors.referral ? carErrors.referral : "Write here.."}`}
                className={`border py-2 px-4 rounded-lg w-full ${
                  carTouchedFields.referral && carErrors.referral
                    ? "placeholder-[#CA0000] border-[#CA0000]"
                    : ""
                }`}
                value={formData.carDetails.referral}
                onChange={handleCarDetailsChange}
              />
              {carTouchedFields.referral && carErrors.referral && (
                <p className="text-[#CA0000] text-sm mt-1">
                  {carErrors.referral}
                </p>
              )}
            </div>
          </div>

          <button
            type="submit"
            className="bg-[#EEECFF] my-4 text-[15px] text-[#CA0000]  font-bold rounded-3xl p-2 mt-4 w-full"
          >
            {mainloading ? <ClipLoader /> : "Save"}
          </button>
        </form>
      </div>
      <Modal
        open={uploadModalOpen}
        onClose={() => {}}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
      >
        <Fade in={uploadModalOpen}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: "90%", sm: "80%", md: "400px" }, // responsive width
              bgcolor: "background.paper",
              borderRadius: "8px",
              boxShadow: 24,
              p: 4,
              outline: "none",
              textAlign: "center",
            }}
          >
            <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
              Uploading Details...
            </Typography>
            <ClipLoader size={35} color="#ca0000" />
            <Typography sx={{ mt: 2, fontSize: "14px", color: "gray" }}>
              Please wait while we save your data.
            </Typography>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
};

export default UploadVehicle;
